export enum resourceTypes {
  LOCATION = 'location',
  EXTRA_LOCATION = 'extra-location',
  ELECTRONICS = 'electronics',
  STATIONERY = 'stationery',
  OTHER = 'other',
}
